import React from 'react';
import { Flex } from '@chakra-ui/react';
import { ArticleTypesSection } from '../ArticleTypesSection';

interface ArticleTypesTabProps {
  orgShortname: string;
  journalId: string;
}

const ArticleTypesTab: React.FC<ArticleTypesTabProps> = ({
  orgShortname,
  journalId
}) => {
  return (
    <Flex flexDirection="column" gap={4} width="100%">
      <ArticleTypesSection orgShortname={orgShortname} journalId={journalId} />
    </Flex>
  );
};

export default React.memo(ArticleTypesTab);
